// Tour/Tutorial
export const nextLocationIDs = 'nextLocationIDs';
export const mainContentObscured = 'mainContentObscured';
export const tourCurrentArticle = 'tourCurrentArticle';

// packageSyncer
export const packageSyncerProgress = 'packageSyncerProgress';
export const packageSyncerPartState = 'packageSyncerPartState';

// Quiz
export const quizResult = 'quizResult';
export const quizCurrentStoreObject = 'quizCurrentStoreObject';
// History
export const historyPrev = 'historyPrev';
export const historyNext = 'historyNext';
export const historyCur = 'historyCur';

// media
export const activeMedia = 'activeMedia';

// main
export const articleCodeMap = 'articleCodeMap';

// viewState
export const viewStateAriaHideMainElements = 'viewStateAriaHideMainElements';

// Dmx
export const dmxArticles = 'dmxArticles';

// Swipe
export const pageTransitionSwipe = 'pageTransitionSwipe';

// scroll
export const getScrolledArticlePosition = 'getScrolledArticlePosition';
